import { useNode } from "@craftjs/core";
import React from "react";
import {
  ColorInput,
  SelectInput,
  UnitInput,
  ToggleInput,
  BoxShadowInput,
  PaddingInput,
  MarginInput,
  Panel,
  Tabs,
  TextInput,
  NumberInput,
  Spacer,
  BorderRadiusInput,
  RichTextFormatting,
  BorderInput,
  RangeNumberInput,
  TabsV2,
  AlignInput,
} from "../../input";
import { supportLibrary } from "../../block-supports";
import { changeTransition, isUpdatedFromDefault } from "../../utils";
import { INPUT_LIMITS } from "../../input-limits";

export const PostCategoriesSettings = () => {
  const {
    id,
    actions: { setProp },
    props,
    dom,
    supports,
  } = useNode((node) => ({
    id: node.id,
    text: node.data.props.text,
    props: node.data.props,
    dom: node.dom,
    supports: node.data?.type?.craft?.related?.supports,
  }));

  const {
    source,
    linkCategory = false,
    maxCategories = 5,
    gapHorizontal,
    gapVertical,
    prefixText,
    attachedPrefixText,
    attachedSuffixText,
    showTags = false,
    separator,
    openCategoryInNewTab = false,
    linkRel,
    categoryColor = "#fff",
    categoryBackgroundColor = "#5ec9ff",
    prefixColor,
    prefixBackgroundColor,
    categoryTypoSize,
    categoryTypoSizeTablet,
    categoryTypoSizeMobile,
    categoryTypoLineHeight,
    categoryTypoLetterSpacing,
    categoryTypoWordSpacing,
    categoryTypoTransform,
    categoryTypoStyle,
    categoryTypoDecoration,
    categoryTypoWeight,
    prefixTypoSize,
    prefixTypoSizeTablet,
    prefixTypoSizeMobile,
    prefixTypoLineHeight,
    prefixTypoLetterSpacing,
    prefixTypoWordSpacing,
    prefixTypoTransform,
    prefixTypoStyle,
    prefixTypoDecoration,
    prefixTypoWeight,
    layoutPadding = { top: "3px", bottom: "3px", left: "10px", right: "10px" },
    layoutPaddingTablet,
    layoutPaddingMobile,
    layoutMargin,
    layoutMarginTablet,
    layoutMarginMobile,
    border,
    borderRadius,
    boxShadow,
    hoverCategoryColor,
    hoverCategoryBackgroundColor,
    hoverPrefixColor,
    hoverPrefixBackgroundColor,
    hoverBorder,
    hoverBorderRadius,
    activeCategoryColor,
    activeCategoryBackgroundColor,
    activePrefixColor,
    activePrefixBackgroundColor,
    activeBorder,
    activeBorderRadius,
    transition,
    allCategory,
    allCategoryLink,
    columnLayout = false,
    align,
    highlightCurrentPostCategory = false,
  } = props;
  function GeneralSettings() {
    return (
      <div className="g-settings__wrapper">
        <Spacer spacing="1rem">
          <NumberInput
            resetValue={5}
            label="Max Categories"
            value={maxCategories}
            onChange={(val) => {
              setProp((props) => {
                if (val < maxCategories) {
                  props.maxCategories = Number(val);
                }
                props.maxCategories = Number(val);
                return props;
              });
            }}
            // min={1}

            min={INPUT_LIMITS["post-categories"].min}
            max={INPUT_LIMITS["post-categories"].max}
            step={INPUT_LIMITS["post-categories"].step}
          />
          <ToggleInput
            resetValue={false}
            label="Column Layout"
            value={columnLayout}
            onChange={(val) => {
              setProp((props) => {
                props.columnLayout = val;
              });
            }}
          />
          {!columnLayout ? (
            <RangeNumberInput
              resetValue={0}
              label="Gap (Horizontal)"
              value={gapHorizontal}
              onChange={(val) => {
                setProp((props) => {
                  props.gapHorizontal = val;
                });
              }}
            />
          ) : (
            <></>
          )}
          <RangeNumberInput
            resetValue={0}
            label="Gap (Vertical)"
            value={gapVertical}
            onChange={(val) => {
              setProp((props) => {
                props.gapVertical = val;
              });
            }}
          />
          <AlignInput
            isResponsive={true}
            resetValue={undefined}
            value={align}
            onChange={(val) => {
              setProp((props) => {
                props.align = val;
              });
            }}
            label={"Align"}
          />
          <TextInput
            minLength={INPUT_LIMITS["post-categories-separator"].minlength}
            maxLength={INPUT_LIMITS["post-categories-separator"].maxlength}
            resetValue={undefined}
            label="Separator"
            value={separator}
            onChange={(val) => {
              setProp((props) => {
                props.separator = val;
              });
            }}
          />
          <ToggleInput
            resetValue={undefined}
            label="Link Category"
            value={linkCategory}
            onChange={(val) => {
              setProp((props) => {
                props.linkCategory = val;
              });
            }}
          />
          {linkCategory && (
            <>
              <ToggleInput
                resetValue={undefined}
                label="Open Category In New Tab"
                value={openCategoryInNewTab}
                onChange={(val) => {
                  setProp((props) => {
                    props.openCategoryInNewTab = val;
                  });
                }}
              />
              <TextInput
                minLength={INPUT_LIMITS["link-relation"].minlength}
                maxLength={INPUT_LIMITS["link-relation"].maxlength}
                resetValue={undefined}
                label="Link Relation"
                value={linkRel}
                onChange={(val) => {
                  setProp((props) => {
                    props.linkRel = val;
                  });
                }}
              />
            </>
          )}
          <SelectInput
            value={source}
            onChange={(val) => {
              setProp((props) => {
                props.source = val;
              });
            }}
            options={[
              {
                label:
                  "Current Post Categories Or All Categories (if used outside of post)",
                value: "",
              },
              {
                label: "All Categories",
                value: "all",
              },
            ]}
            label="Source"
          />
          <ToggleInput
            resetValue={undefined}
            label="Highlight Current Post Category"
            value={highlightCurrentPostCategory}
            onChange={(val) => {
              setProp((props) => {
                props.highlightCurrentPostCategory = val;
              });
            }}
          />
          <ToggleInput
            resetValue={undefined}
            label="Display Post Tags"
            value={showTags}
            onChange={(val) => {
              setProp((props) => {
                props.showTags = val;
              });
            }}
          />
          <TextInput
            minLength={INPUT_LIMITS["post-prefix"].minlength}
            maxLength={INPUT_LIMITS["post-prefix"].maxlength}
            resetValue={undefined}
            label="Prefix Text"
            value={prefixText}
            onChange={(val) => {
              setProp((props) => {
                props.prefixText = val;
              });
            }}
          />
          {showTags && (
            <>
              <TextInput
                minLength={
                  INPUT_LIMITS["post-categories-attached-prefix"].minlength
                }
                maxLength={
                  INPUT_LIMITS["post-categories-attached-prefix"].maxlength
                }
                resetValue={undefined}
                label="Attached Prefix Text"
                value={attachedPrefixText}
                onChange={(val) => {
                  setProp((props) => {
                    props.attachedPrefixText = val;
                  });
                }}
              />

              <TextInput
                resetValue={undefined}
                minLength={
                  INPUT_LIMITS["post-categories-attached-suffix"].minlength
                }
                maxLength={
                  INPUT_LIMITS["post-categories-attached-suffix"].maxlength
                }
                label="Attached Suffix Text"
                value={attachedSuffixText}
                onChange={(val) => {
                  setProp((props) => {
                    props.attachedSuffixText = val;
                  });
                }}
              />
            </>
          )}
          <ToggleInput
            resetValue={undefined}
            label="All Category"
            value={allCategory}
            onChange={(val) => {
              setProp((props) => {
                props.allCategory = val;
              });
            }}
          />
          {allCategory ? (
            <>
              <TextInput
                minLength={INPUT_LIMITS["outbound-link"].minlength}
                maxLength={INPUT_LIMITS["outbound-link"].maxlength}
                resetValue={undefined}
                label="All Category Link"
                value={allCategoryLink}
                onChange={(val) => {
                  setProp((props) => {
                    props.allCategoryLink = val;
                  });
                }}
              />
            </>
          ) : (
            <></>
          )}
        </Spacer>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: categoryTypoSize },
            { key: categoryTypoSizeTablet },
            { key: categoryTypoSizeMobile },
            { key: categoryTypoLineHeight },
            { key: categoryTypoLetterSpacing },
            { key: categoryTypoWordSpacing },
            { key: categoryTypoWeight },
            { key: categoryTypoTransform },
            { key: categoryTypoDecoration },
            { key: categoryTypoStyle },
          ])}
          id={`block-setting-${id}-typography-categories`}
          title={"Typography - Categories"}
          initialOpen={false}
        >
          <UnitInput
            value={categoryTypoSize}
            isResponsive={true}
            valueTablet={categoryTypoSizeTablet}
            valueMobile={categoryTypoSizeMobile}
            onChange={(val) => {
              setProp((props) => {
                props.categoryTypoSize = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.categoryTypoSizeTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.categoryTypoSizeMobile = val;
              });
            }}
            label={"Size"}
          />
          <UnitInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={categoryTypoLineHeight}
            onChange={(val) => {
              setProp((props) => {
                props.categoryTypoLineHeight = val;
              });
            }}
            label={"Line Height"}
          />
          <UnitInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={categoryTypoLetterSpacing}
            onChange={(val) => {
              setProp((props) => {
                props.categoryTypoLetterSpacing = val;
              });
            }}
            label={"Letter Spacing"}
          />
          <UnitInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={categoryTypoWordSpacing}
            onChange={(val) => {
              setProp((props) => {
                props.categoryTypoWordSpacing = val;
              });
            }}
            label={"Word Spacing"}
          />
          <SelectInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={categoryTypoWeight}
            onChange={(val) => {
              setProp((props) => {
                props.categoryTypoWeight = val;
              });
            }}
            options={[
              { label: "100", value: "100" },
              { label: "200", value: "200" },
              { label: "300", value: "300" },
              { label: "400", value: "400" },
              { label: "500", value: "500" },
              { label: "600", value: "600" },
              { label: "700", value: "700" },
              { label: "800", value: "800" },
              { label: "900", value: "900" },
            ]}
            label="Weight"
          />
          <SelectInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={categoryTypoTransform}
            onChange={(val) => {
              setProp((props) => {
                props.categoryTypoTransform = val;
              });
            }}
            options={[
              { label: "Uppercase", value: "uppercase" },
              { label: "Lowercase", value: "lowercase" },
              { label: "Capitalize", value: "capitalize" },
              { label: "None", value: "none" },
            ]}
            label="Transform"
          />
          <SelectInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={categoryTypoDecoration}
            onChange={(val) => {
              setProp((props) => {
                props.categoryTypoDecoration = val;
              });
            }}
            options={[
              { label: "Underline", value: "underline" },
              { label: "Overline", value: "overline" },
              { label: "None", value: "none" },
            ]}
            label="Decoration"
          />
          <SelectInput
            resetValue={undefined}
            value={categoryTypoStyle}
            onChange={(val) => {
              setProp((props) => {
                props.categoryTypoStyle = val;
              });
            }}
            options={[
              {
                label: "Normal",
                value: "normal",
              },
              {
                label: "Italic",
                value: "italic",
              },
            ]}
            label="Style"
          />
        </Panel>{" "}
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: prefixTypoSize },
            { key: prefixTypoSizeTablet },
            { key: prefixTypoSizeMobile },
            { key: prefixTypoLineHeight },
            { key: prefixTypoLetterSpacing },
            { key: prefixTypoWordSpacing },
            { key: prefixTypoWeight },
            { key: prefixTypoTransform },
            { key: prefixTypoDecoration },
            { key: prefixTypoStyle },
          ])}
          id={`block-setting-${id}-typography-prefix`}
          title={"Typography - Prefix"}
          initialOpen={false}
        >
          <UnitInput
            value={prefixTypoSize}
            isResponsive={true}
            valueTablet={prefixTypoSizeTablet}
            valueMobile={prefixTypoSizeMobile}
            onChange={(val) => {
              setProp((props) => {
                props.prefixTypoSize = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.prefixTypoSizeTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.prefixTypoSizeMobile = val;
              });
            }}
            label={"Size"}
          />
          <UnitInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={prefixTypoLineHeight}
            onChange={(val) => {
              setProp((props) => {
                props.prefixTypoLineHeight = val;
              });
            }}
            label={"Line Height"}
          />
          <UnitInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={prefixTypoLetterSpacing}
            onChange={(val) => {
              setProp((props) => {
                props.prefixTypoLetterSpacing = val;
              });
            }}
            label={"Letter Spacing"}
          />
          <UnitInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={prefixTypoWordSpacing}
            onChange={(val) => {
              setProp((props) => {
                props.prefixTypoWordSpacing = val;
              });
            }}
            label={"Word Spacing"}
          />
          <SelectInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={prefixTypoWeight}
            onChange={(val) => {
              setProp((props) => {
                props.prefixTypoWeight = val;
              });
            }}
            options={[
              { label: "100", value: "100" },
              { label: "200", value: "200" },
              { label: "300", value: "300" },
              { label: "400", value: "400" },
              { label: "500", value: "500" },
              { label: "600", value: "600" },
              { label: "700", value: "700" },
              { label: "800", value: "800" },
              { label: "900", value: "900" },
            ]}
            label="Weight"
          />
          <SelectInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={prefixTypoTransform}
            onChange={(val) => {
              setProp((props) => {
                props.prefixTypoTransform = val;
              });
            }}
            options={[
              { label: "Uppercase", value: "uppercase" },
              { label: "Lowercase", value: "lowercase" },
              { label: "Capitalize", value: "capitalize" },
              { label: "None", value: "none" },
            ]}
            label="Transform"
          />
          <SelectInput
            resetValue={undefined}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={prefixTypoDecoration}
            onChange={(val) => {
              setProp((props) => {
                props.prefixTypoDecoration = val;
              });
            }}
            options={[
              { label: "Underline", value: "underline" },
              { label: "Overline", value: "overline" },
              { label: "None", value: "none" },
            ]}
            label="Decoration"
          />
          <SelectInput
            resetValue={undefined}
            value={prefixTypoStyle}
            onChange={(val) => {
              setProp((props) => {
                props.prefixTypoStyle = val;
              });
            }}
            options={["normal", "italic"].map(function (item) {
              return {
                label: item,
                value: item,
              };
            })}
            label="Style"
          />
        </Panel>
        <RichTextFormatting />
      </div>
    );
  }

  function StyleSettings() {
    const categoryColorTabs = [
      {
        label: "Initial",
        key: "initial",
        children: handleColorStates({
          categoryColorPropKey: "categoryColor",
          categoryColorProp: categoryColor,
          categoryBackgroundColorPropKey: "categoryBackgroundColor",
          categoryBackgroundColorProp: categoryBackgroundColor,
        }),
      },
      {
        label: "Hover",
        key: "hover",
        children: handleColorStates({
          categoryColorPropKey: "hoverCategoryColor",
          categoryColorProp: hoverCategoryColor,
          categoryBackgroundColorPropKey: "hoverCategoryBackgroundColor",
          categoryBackgroundColorProp: hoverCategoryBackgroundColor,
        }),
      },
      {
        label: "Active",
        key: "active",
        children: handleColorStates({
          categoryColorPropKey: "activeCategoryColor",
          categoryColorProp: activeCategoryColor,
          categoryBackgroundColorPropKey: "activeCategoryBackgroundColor",
          categoryBackgroundColorProp: activeCategoryBackgroundColor,
        }),
      },
    ];

    function handleColorStates({
      categoryColorPropKey,
      categoryColorProp,
      categoryBackgroundColorPropKey,
      categoryBackgroundColorProp,
    }) {
      return (
        <>
          <ColorInput
            resetValue={"#fff"}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={categoryColorProp}
            onChange={(val) => {
              setProp((props) => {
                props[categoryColorPropKey] = val;
              });
            }}
            label={"Text"}
          />
          <ColorInput
            resetValue={"#5ec9ff"}
            resetValueTablet={undefined}
            resetValueMobile={undefined}
            value={categoryBackgroundColorProp}
            onChange={(val) => {
              setProp((props) => {
                props[categoryBackgroundColorPropKey] = val;
              });
            }}
            label={"Category"}
          />
          {(categoryColorPropKey === "hoverCategoryColor" ||
            categoryBackgroundColorPropKey ===
              "hoverCategoryBackgroundColor") && (
            <RangeNumberInput
              min={0}
              max={10}
              step={0.05}
              value={
                transition?.types?.[("color", "background-color")]?.duration
              }
              onChange={(val) => {
                changeTransition(
                  ["color", "background-color"],
                  { duration: val },
                  transition,
                  setProp,
                );
              }}
              label={"Transition Time"}
            />
          )}
        </>
      );
    }

    const prefixColorTabs = [
      {
        label: "Initial",
        key: "initial",
        children: handlePrefixColorStates({
          prefixColorPropKey: "prefixColor",
          prefixColorProp: prefixColor,
          prefixBackgroundColorPropKey: "prefixBackgroundColor",
          prefixBackgroundColorProp: prefixBackgroundColor,
        }),
      },
      {
        label: "Hover",
        key: "hover",
        children: handlePrefixColorStates({
          prefixColorPropKey: "hoverPrefixColor",
          prefixColorProp: hoverPrefixColor,
          prefixBackgroundColorPropKey: "hoverPrefixBackgroundColor",
          prefixBackgroundColorProp: hoverPrefixBackgroundColor,
        }),
      },
      {
        label: "Active",
        key: "active",
        children: handlePrefixColorStates({
          prefixColorPropKey: "activePrefixColor",
          prefixColorProp: activePrefixColor,
          prefixBackgroundColorPropKey: "activePrefixBackgroundColor",
          prefixBackgroundColorProp: activePrefixBackgroundColor,
        }),
      },
    ];

    function handlePrefixColorStates({
      prefixColorPropKey,
      prefixColorProp,
      prefixBackgroundColorPropKey,
      prefixBackgroundColorProp,
    }) {
      return (
        <>
          <ColorInput
            resetValue={undefined}
            value={prefixColorProp}
            onChange={(val) => {
              setProp((props) => {
                props[prefixColorPropKey] = val;
              });
            }}
            label={"Text"}
          />
          <ColorInput
            resetValue={undefined}
            value={prefixBackgroundColorProp}
            onChange={(val) => {
              setProp((props) => {
                props[prefixBackgroundColorPropKey] = val;
              });
            }}
            label={"Background"}
          />
          {(prefixColorPropKey === "hoverPrefixColor" ||
            prefixBackgroundColorPropKey === "hoverPrefixBackgroundColor") && (
            <RangeNumberInput
              min={0}
              max={10}
              step={0.05}
              value={
                transition?.types?.[("color", "background-color")]?.duration
              }
              onChange={(val) => {
                changeTransition(
                  ["color", "background-color"],
                  { duration: val },
                  transition,
                  setProp,
                );
              }}
              label={"Transition Time"}
            />
          )}
        </>
      );
    }

    return (
      <>
        <Spacer spacing={"1rem"}>
          <TabsV2 items={categoryColorTabs} />
        </Spacer>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: prefixColor },
            { key: prefixBackgroundColor },
            { key: hoverPrefixColor },
            { key: hoverPrefixBackgroundColor },
            { key: activePrefixColor },
            { key: activePrefixBackgroundColor },
          ])}
          id={`block-setting-${id}-prefix`}
          title={"Prefix"}
          initialOpen={false}
        >
          <TabsV2 items={prefixColorTabs} />
        </Panel>
      </>
    );
  }

  function AdvancedSettings() {
    const borderTabs = [
      {
        label: "Initial",
        key: "initial",
        children: handleBorderStates({
          borderPropKey: "border",
          borderProp: border,
          borderRadiusPropKey: "borderRadius",
          borderRadiusProp: borderRadius,
        }),
      },
      {
        label: "Hover",
        key: "hover",
        children: handleBorderStates({
          borderPropKey: "hoverBorder",
          borderProp: hoverBorder,
          borderRadiusPropKey: "hoverBorderRadius",
          borderRadiusProp: hoverBorderRadius,
        }),
      },
      {
        label: "Active",
        key: "active",
        children: handleBorderStates({
          borderPropKey: "activeBorder",
          borderProp: activeBorder,
          borderRadiusPropKey: "activeBorderRadius",
          borderRadiusProp: activeBorderRadius,
        }),
      },
    ];

    function handleBorderStates({
      borderPropKey,
      borderProp,
      borderRadiusPropKey,
      borderRadiusProp,
    }) {
      return (
        <>
          <BorderInput
            resetValue={undefined}
            value={borderProp}
            onChange={(val) => {
              setProp((props) => {
                props[borderPropKey] = val;
              });
            }}
            label={"Border"}
          />
          <BorderRadiusInput
            resetValue={undefined}
            value={borderRadiusProp}
            onChange={(val) => {
              setProp((props) => {
                props[borderRadiusPropKey] = val;
              });
            }}
            label={"Border Radius"}
          />
          {(borderPropKey === "hoverBorder" ||
            borderRadiusPropKey === "hoverBorderRadius") && (
            <RangeNumberInput
              min={0}
              max={10}
              step={0.05}
              value={transition?.types?.[("border", "border-radius")]?.duration}
              onChange={(val) => {
                changeTransition(
                  ["border", "border-radius"],
                  { duration: val },
                  transition,
                  setProp,
                );
              }}
              label={"Transition Time"}
            />
          )}
        </>
      );
    }
    return (
      <>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: layoutMargin },
            { key: layoutMarginTablet },
            { key: layoutMarginMobile },
            {
              key: layoutPadding,
              default: {
                top: "3px",
                bottom: "3px",
                left: "10px",
                right: "10px",
              },
            },
            { key: layoutPaddingTablet },
            { key: layoutPaddingMobile },
          ])}
          id={`block-setting-${id}-layout`}
          title={"Layout"}
          initialOpen={true}
        >
          <MarginInput
            isResponsive={true}
            value={layoutMargin}
            valueTablet={layoutMarginTablet}
            valueMobile={layoutMarginMobile}
            onChange={(val) => {
              setProp((props) => {
                props.layoutMargin = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.layoutMarginTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.layoutMarginMobile = val;
              });
            }}
            label={"Margin"}
          />
          <PaddingInput
            resetValue={{
              top: "3px",
              bottom: "3px",
              left: "10px",
              right: "10px",
            }}
            isResponsive={true}
            value={layoutPadding}
            valueTablet={layoutPaddingTablet}
            valueMobile={layoutPaddingMobile}
            onChange={(val) => {
              setProp((props) => {
                props.layoutPadding = val;
              });
            }}
            setValueTablet={(val) => {
              setProp((props) => {
                props.layoutPaddingTablet = val;
              });
            }}
            setValueMobile={(val) => {
              setProp((props) => {
                props.layoutPaddingMobile = val;
              });
            }}
            label={"Padding"}
          />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([
            { key: border },
            { key: borderRadius },
            { key: hoverBorder },
            { key: hoverBorderRadius },
            { key: activeBorder },
            { key: activeBorderRadius },
          ])}
          id={`block-setting-${id}-border`}
          title={"Border"}
          initialOpen={false}
        >
          <TabsV2 items={borderTabs} />
        </Panel>
        <Panel
          isUpdated={isUpdatedFromDefault([{ key: boxShadow }])}
          id={`block-setting-${id}-box-shadow`}
          title={"Box Shadow"}
          initialOpen={false}
        >
          <BoxShadowInput
            resetValue={undefined}
            value={boxShadow}
            onChange={(val) => {
              setProp((props) => {
                props.boxShadow = val;
              });
            }}
          />
        </Panel>
        {supports &&
          supports.map((support) => {
            var Component = supportLibrary[support]?.component;

            if (!Component) {
              return;
            }

            return (
              <>
                <Component
                  block={{
                    id,
                    props,
                    dom,
                  }}
                  actions={{
                    setProp,
                  }}
                ></Component>
              </>
            );
          })}
      </>
    );
  }
  const tabs = [
    {
      label: "General",
      key: "general",
      children: GeneralSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: maxCategories },
        { key: gapHorizontal },
        { key: gapVertical },
        { key: separator },
        { key: openCategoryInNewTab },
        { key: showTags },
        { key: prefixText },
        { key: attachedPrefixText },
        { key: attachedSuffixText },
        { key: linkRel },
        { key: categoryTypoSize },
        { key: categoryTypoSizeTablet },
        { key: categoryTypoSizeMobile },
        { key: categoryTypoLineHeight },
        { key: categoryTypoLetterSpacing },
        { key: categoryTypoWordSpacing },
        { key: categoryTypoWeight },
        { key: categoryTypoTransform },
        { key: categoryTypoDecoration },
        { key: categoryTypoStyle },
        { key: prefixTypoSize },
        { key: prefixTypoSizeTablet },
        { key: prefixTypoSizeMobile },
        { key: prefixTypoLineHeight },
        { key: prefixTypoLetterSpacing },
        { key: prefixTypoWordSpacing },
        { key: prefixTypoWeight },
        { key: prefixTypoTransform },
        { key: prefixTypoDecoration },
        { key: prefixTypoStyle },
      ]),
    },
    {
      label: "Style",
      key: "style",
      children: StyleSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: categoryColor },
        { key: categoryBackgroundColor },
        { key: prefixColor },
        { key: prefixBackgroundColor },
        { key: hoverPrefixColor },
        { key: hoverPrefixBackgroundColor },
        { key: activePrefixColor },
        { key: activePrefixBackgroundColor },
      ]),
    },
    {
      label: "Advanced",
      key: "advanced",
      children: AdvancedSettings(),
      isUpdated: isUpdatedFromDefault([
        { key: layoutMargin },
        { key: layoutMarginTablet },
        { key: layoutMarginMobile },
        {
          key: layoutPadding,
          default: { top: "3px", bottom: "3px", left: "10px", right: "10px" },
        },
        { key: layoutPaddingTablet },
        { key: layoutPaddingMobile },
        { key: border },
        { key: boxShadow },
        { key: borderRadius },
        { key: hoverBorder },
        { key: hoverBorderRadius },
        { key: activeBorder },
        { key: activeBorderRadius },
      ]),
    },
  ];

  return (
    <div>
      <Tabs type="block-setting" id={`block-settings-tab-${id}`} items={tabs} />
    </div>
  );
};
